(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["checklist-status-bar"] && !Shopify.designMode) return;
  try {
    if (!window.__checklistStatusBarReady) {
    window.__checklistStatusBarReady = true;

    function normText(str) {
      return (str || '').replace(/[\s\u00a0]+/g, ' ').trim().toLowerCase();
    }

    function getStickyOffset() {
      const header = document.getElementById('header-component');
      return header ? header.getBoundingClientRect().height + 16 : 80;
    }

    function isExcluded(el) {
      return Boolean(
        el.closest('.toc-section, [data-table-content], [data-checklist-status-bar]')
      );
    }

    function findTarget(targetText) {
      const normalized = normText(targetText);
      if (!normalized) return null;

      const scopes = [
        document.querySelectorAll(
          'h1, h2, h3, h4, h5, h6, .text-block--heading, [data-toc-target]'
        ),
        document.querySelectorAll(
          '.blog-post-content strong, .blog-post-content b, .rte strong, .rte b'
        ),
        document.querySelectorAll('.blog-post-content p, .blog-post-content li, .rte p, .rte li'),
      ];

      let partialMatch = null;

      for (const candidates of scopes) {
        for (const el of candidates) {
          if (isExcluded(el)) continue;
          const elText = normText(el.textContent);
          if (!elText) continue;
          if (elText === normalized) return el;
          if (!partialMatch && elText.includes(normalized)) partialMatch = el;
        }
        if (partialMatch) return partialMatch;
      }

      return partialMatch;
    }

    function scrollToTarget(target) {
      const offset = getStickyOffset();
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }

    function initBar(bar) {
      const steps = Array.from(bar.querySelectorAll('[data-checklist-step]'));
      if (!steps.length) return;

      const entries = steps
        .map((step) => {
          const link = step.querySelector('[data-checklist-target-text]');
          const targetText = link?.getAttribute('data-checklist-target-text');
          const target = findTarget(targetText);
          return { step, link, target };
        })
        .filter((entry) => entry.target);

      if (!entries.length) return;

      let lastActiveIndex = -1;

      function scrollActiveIntoView(activeStep) {
        if (!activeStep) return;

        const barRect = bar.getBoundingClientRect();
        const stepRect = activeStep.getBoundingClientRect();
        const delta =
          stepRect.left + stepRect.width / 2 - (barRect.left + barRect.width / 2);

        if (Math.abs(delta) < 4) return;

        bar.scrollBy({ left: delta, behavior: 'smooth' });
      }

      function setActive(activeIndex) {
        steps.forEach((step, index) => {
          const isActive = index === activeIndex;
          const isComplete = index < activeIndex;
          step.classList.toggle('is-active', isActive);
          step.classList.toggle('is-complete', isComplete);
          const link = step.querySelector('.checklist-status-bar__link');
          if (link) link.setAttribute('aria-current', isActive ? 'step' : 'false');
        });

        if (activeIndex !== lastActiveIndex) {
          lastActiveIndex = activeIndex;
          scrollActiveIntoView(steps[activeIndex]);
        }
      }

      function updateFromScroll() {
        const marker = getStickyOffset() + 24;
        let activeIndex = 0;

        entries.forEach((entry, index) => {
          const top = entry.target.getBoundingClientRect().top;
          if (top <= marker) activeIndex = index;
        });

        setActive(activeIndex);
      }

      let ticking = false;
      window.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            updateFromScroll();
            ticking = false;
          });
        },
        { passive: true }
      );

      window.addEventListener('resize', updateFromScroll, { passive: true });
      updateFromScroll();
    }

    function initAll() {
      document.querySelectorAll('[data-checklist-status-bar]').forEach(initBar);
    }

    document.addEventListener('click', (e) => {
      const link = e.target.closest('.checklist-status-bar__link');
      if (!link) return;

      e.preventDefault();

      const targetText = link.getAttribute('data-checklist-target-text');
      if (!targetText) return;

      const target = findTarget(targetText);
      if (!target) return;

      scrollToTarget(target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jump-buttons"] && !Shopify.designMode) return;
  try {
    if (!window.__jumpButtonsReady) {
    window.__jumpButtonsReady = true;

    function normText(str) {
      return (str || '').replace(/[\s\u00a0]+/g, ' ').trim().toLowerCase();
    }

    function getStickyOffset() {
      const header = document.getElementById('header-component');
      return header ? header.getBoundingClientRect().height + 16 : 80;
    }

    function isExcluded(el) {
      return Boolean(
        el.closest(
          '.toc-section, [data-table-content], [data-checklist-status-bar], [data-jump-buttons]'
        )
      );
    }

    function findJumpTarget(targetText) {
      const normalized = normText(targetText);
      if (!normalized) return null;

      const candidates = document.querySelectorAll(
        '.blog-post-content h2, .blog-post-content h3, .rte h2, .rte h3, h2, h3'
      );

      let partialMatch = null;

      for (const el of candidates) {
        if (isExcluded(el)) continue;
        const elText = normText(el.textContent);
        if (!elText) continue;
        if (elText === normalized) return el;
        if (!partialMatch && elText.includes(normalized)) partialMatch = el;
      }

      return partialMatch;
    }

    function scrollToTarget(target) {
      const offset = getStickyOffset();
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }

    document.addEventListener('click', (e) => {
      const link = e.target.closest('.jump-buttons__link');
      if (!link) return;

      e.preventDefault();

      const targetText = link.getAttribute('data-jump-target-text');
      if (!targetText) return;

      const target = findJumpTarget(targetText);
      if (!target) return;

      scrollToTarget(target);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-links-list"] && !Shopify.designMode) return;
  try {
    if (!window.__inThisGuideReady) {
    window.__inThisGuideReady = true;

    function normText(str) {
      return (str || '').replace(/[\s\u00a0]+/g, ' ').trim().toLowerCase();
    }

    function getStickyOffset() {
      const header = document.getElementById('header-component');
      return header ? header.getBoundingClientRect().height + 16 : 80;
    }

    function isExcluded(el) {
      return Boolean(
        el.closest(
          '.toc-section, [data-table-content], [data-checklist-status-bar], [data-jump-buttons], [data-in-this-guide]'
        )
      );
    }

    function findGuideTarget(targetText) {
      const normalized = normText(targetText);
      if (!normalized) return null;

      const candidates = document.querySelectorAll(
        '.blog-post-content h2, .blog-post-content h3, .rte h2, .rte h3, h2, h3'
      );

      let partialMatch = null;

      for (const el of candidates) {
        if (isExcluded(el)) continue;
        const elText = normText(el.textContent);
        if (!elText) continue;
        if (elText === normalized) return el;
        if (!partialMatch && elText.includes(normalized)) partialMatch = el;
      }

      return partialMatch;
    }

    function scrollToTarget(target) {
      const offset = getStickyOffset();
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }

    function setActiveLink(activeLink) {
      document.querySelectorAll('.in-this-guide__link.is-active').forEach((link) => {
        link.classList.remove('is-active');
      });
      if (activeLink) activeLink.classList.add('is-active');
    }

    function updateActiveFromScroll() {
      const links = Array.from(document.querySelectorAll('.in-this-guide__link'));
      if (!links.length) return;

      const offset = getStickyOffset() + 8;
      let currentLink = links[0];

      for (const link of links) {
        const targetText = link.getAttribute('data-guide-target-text');
        const target = findGuideTarget(targetText);
        if (!target) continue;
        if (target.getBoundingClientRect().top - offset <= 0) {
          currentLink = link;
        }
      }

      setActiveLink(currentLink);
    }

    document.addEventListener('click', (e) => {
      const link = e.target.closest('.in-this-guide__link');
      if (!link) return;

      e.preventDefault();

      const targetText = link.getAttribute('data-guide-target-text');
      if (!targetText) return;

      const target = findGuideTarget(targetText);
      if (!target) return;

      setActiveLink(link);
      scrollToTarget(target);
    });

    window.addEventListener('scroll', updateActiveFromScroll, { passive: true });
    window.addEventListener('load', updateActiveFromScroll);
    updateActiveFromScroll();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["table-content"] && !Shopify.designMode) return;
  try {
    if (!window.__tableContentScrollReady) {
    window.__tableContentScrollReady = true;

    function normText(str) {
      return (str || '').replace(/[\s\u00a0]+/g, ' ').trim().toLowerCase();
    }

    function getStickyOffset() {
      const header = document.getElementById('header-component');
      return header ? header.getBoundingClientRect().height + 16 : 80;
    }

    function isExcluded(el) {
      return Boolean(
        el.closest(
          '.toc-section, [data-table-content], [data-checklist-status-bar], [data-jump-buttons], [data-in-this-guide]'
        )
      );
    }

    function findTarget(targetText) {
      const normalized = normText(targetText);
      if (!normalized) return null;

      const scopes = [
        document.querySelectorAll(
          'h1, h2, h3, h4, h5, h6, .text-block--heading, [data-toc-target]'
        ),
        document.querySelectorAll(
          '.blog-post-content strong, .blog-post-content b, .rte strong, .rte b'
        ),
        document.querySelectorAll('.blog-post-content p, .blog-post-content li, .rte p, .rte li'),
      ];

      let partialMatch = null;

      for (const candidates of scopes) {
        for (const el of candidates) {
          if (isExcluded(el)) continue;
          const elText = normText(el.textContent);
          if (!elText) continue;
          if (elText === normalized) return el;
          if (!partialMatch && elText.includes(normalized)) partialMatch = el;
        }
        if (partialMatch) return partialMatch;
      }

      return partialMatch;
    }

    function scrollToTarget(target) {
      const offset = getStickyOffset();
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }

    function markScrollableItems(box) {
      box.querySelectorAll('.table-content__body li').forEach((li) => {
        const target = findTarget(li.textContent);
        if (target) {
          li.setAttribute('data-scroll-target', 'true');
        } else {
          li.removeAttribute('data-scroll-target');
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-table-content]').forEach(markScrollableItems);
    }

    document.addEventListener('click', (e) => {
      const link = e.target.closest('.table-content__body a[href]');
      if (link) {
        const href = link.getAttribute('href') || '';
        if (href && href !== '#') return;
      }

      const li = e.target.closest('.table-content__body li');
      if (!li) return;

      const target = findTarget(li.textContent);
      if (!target) return;

      e.preventDefault();
      scrollToTarget(target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
